import React from 'react';
import Sidenavigation from '../../Manager/Layouts/Sidenavigation';
import Topnavigation from '../../Manager/Layouts/Topnavigation';
import Content from '../../CommonFolders/Current-Orders-List/Content';
import { Helmet } from "react-helmet";

export default function ManagerCurrentOrdersList() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Current Orders</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='Manager' />
                {/* page content end  */}

            </main>

        </div>
    );
};